import type { MinigameMove, MiningView } from '@wyn/contracts';

/** The Deep Shaft: every swing is a move the server checks against the hidden face. */
export function MiningGame({ view, busy, onMove }: { view: MiningView; busy: boolean; onMove: (m: MinigameMove) => void }) {
  return (
    <div className="space-y-3">
      <p className="text-sm text-ink-dim">
        Tap a spot to swing your pick. A number shows how much ore touches that spot (diagonals count). 〰 means an unstable pocket is next to it. A second collapse caves the tunnel in.
      </p>
      <div className="flex flex-wrap justify-between gap-2 font-mono text-sm">
        <span>Swings <b>{view.swings}</b></span>
        <span>Ore <b className="text-gilt">{view.found}</b>/{view.ore}</span>
        <span>Collapses <b className={view.collapses ? 'text-blood' : ''}>{view.collapses}</b>/{view.maxCollapses}</span>
      </div>
      <div className="mx-auto grid max-w-[330px] gap-1" style={{ gridTemplateColumns: `repeat(${view.width}, 1fr)` }}>
        {view.cells.map((c, i) => {
          const hidden = view.revealed?.[i];
          const label = c === null ? `Rock ${i + 1}` : c.kind === 'rock' ? `Dug: ${c.ore} ore nearby${c.cracked ? ', cracked' : ''}` : c.kind;
          return (
            <button
              key={i}
              type="button"
              aria-label={label}
              disabled={busy || view.over || c !== null}
              onClick={() => onMove({ type: 'swing', cell: i })}
              className={`aspect-square border text-sm transition-colors ${
                c === null ? 'border-rule bg-[#3b362e] hover:border-gilt disabled:hover:border-rule'
                : c.kind === 'ore' ? 'border-gilt/60 bg-[#4a3f1c]'
                : c.kind === 'unstable' ? 'border-blood/60 bg-[#4a1f18]'
                : 'border-rule bg-[#1f1c18]'
              } ${c === null && hidden ? 'opacity-50' : ''}`}
            >
              {c?.kind === 'ore' ? '💎' : c?.kind === 'unstable' ? '💥' : c?.kind === 'rock' ? (
                <>
                  {c.ore > 0 && <span className="text-gilt">✨{c.ore}</span>}
                  {c.cracked && <span className="text-blood">〰</span>}
                </>
              ) : hidden === 'ore' ? '💎' : hidden === 'unstable' ? '〰' : ''}
            </button>
          );
        })}
      </div>
      <button type="button" className="btn w-full" disabled={busy || view.over} onClick={() => onMove({ type: 'leave' })}>
        Leave the mine
      </button>
    </div>
  );
}
